import React from 'react';

type Props = {
  children: React.ReactNode;
};

export const CustomerLayout: React.FC<Props> = ({ children }) => {
  return (
    <>
      <a className="visually-hidden-focusable section__skip" href="#main"></a>
      <main className="shell__page" role="main">
        <picture className="shell__bg" aria-hidden="true">
          <source type="image/jpg" media="(max-width: 430px)" srcSet="public/assets/images/bg.jpg" />
          <source type="image/jpg" media="(max-width: 430px)" srcSet="public/assets/images/bg.jpg" />
          <source type="image/jpg" media="(max-width: 834px)" srcSet="public/assets/images/bg.jpg" />
          <source type="image/jpg" media="(max-width: 834px)" srcSet="public/assets/images/bg.jpg" />
          <source type="image/jpg" media="(min-width: 835px)" srcSet="public/assets/images/bg.jpg" />
          <img src="public/assets/images/bg.jpg" width="1512" height="982" fetch-priority="high" alt="" />
        </picture>
        <div className="shell__scrim" aria-hidden="true" />
        <div id="main">{children}</div>
      </main>
    </>
  );
};
